<!-- city-select 城市选择 -->

<template>
  <div class="box1 flex-row row-between col-center">
    <van-dropdown-menu>
      <van-dropdown-item :title="$store.getters.city_name">
        <van-tree-select :active-id.sync="activeId" :items="items" :main-active-index.sync="activeIndex"
          @click-item="changeCity" />
      </van-dropdown-item>
    </van-dropdown-menu>

    <div style="z-index: 999">
      <search :data="searchKey" style="width: 260px" @search="onSearch"></search>
    </div>
  </div>
</template>

<script>
import { areaList } from "@vant/area-data";
import store from "@/store";

export default {
  name: "index",

  props: {
    // 商品类别：
    cateId: { type: Number, default: 0, required: true },
    includeCateIds: { type: Array, required: false },
    searchBackgroundColor: { type: String, default: "#ffffff" },
    searchStop: { type: Boolean, default: false },
    searchKey: { type: String, default: '' }
  },

  data() {
    return {
      areaList,
      items: [],
      activeId: 5101,
      activeIndex: 0,
      active: 0,
      search: {
        city: 0,
        keyword: "",
      },
    }
  },

  mounted() {
    budo_log.debug("#63 city-select mounted", this)
  },

  created() {
    budo_log.debug("#67 city-select created", this)

    // 加载城市列表
    for (const pid in this.areaList.province_list) {
      const node = {
        text: this.areaList.province_list[pid],
        children: [],
      };

      const cityList = [];
      for (const cid in this.areaList.city_list) {
        if (cid.substring(0, 2) === pid.substring(0, 2)) {
          cityList.push({ text: this.areaList.city_list[cid], id: cid });
        }
      }

      node.children = cityList;
      this.items.push(node);
    }
    this.active = this.$store.getters.city_code;
  },

  methods: {
    goUserCenter() {
      location.href = "/web/user-center-index"
    },

    changeCity(data) {
      budo_log.info("#80 SET_CITY_NAME", data)

      store.commit("SET_CITY_CODE", data.id.substring(0, 4));
      store.commit("SET_CITY_NAME", data.text);
      window.location.reload();
    },

    onSearch(value) {
      this.$emit('searchKey', value);

      if (!this.searchStop) {
        this.$router.push({
          path: "goods-list",
          query: {
            searchType: 1,
            includeCateIds: Array.isArray(this.includeCateIds) ? this.includeCateIds.join(',') : '',
            cateId: this.cateId,
            value,
          },
        });
      }
    }
  }
}
</script>
